import { render, staticRenderFns } from "./studentRankTable.vue?vue&type=template&id=45f6584e&scoped=true"
import script from "./studentRankTable.vue?vue&type=script&lang=js"
export * from "./studentRankTable.vue?vue&type=script&lang=js"
import style0 from "./studentRankTable.vue?vue&type=style&index=0&id=45f6584e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f6584e",
  null
  
)

export default component.exports